export enum QuestionTypeEnum {
    FILL = "Fill",
    MULTIPLE = "Multiple",
    SHORT = "Short",
    TRUE_FALSE = "True_false",
    ESSAY = "Essay",
}
